import { ChangeDetectionStrategy, Component, computed, HostBinding, input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'lbt-text',
  templateUrl: './text.component.html',
  styleUrl: './text.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass]
})
export class TextComponent {
  readonly typography = input<string>('body2');
  readonly typographyMobile = input<string | null>(null);
  readonly color = input<string>('black-8');
  readonly bold = input<boolean>(false);
  readonly hideOverflowEllipsis = input<boolean>(false);
  readonly hoverColor = input<string | null>(null);


  private readonly textColorValue= computed<string>(() => `var(--color-${this.color()})`);
  private readonly fontWeightValue= computed<string>(() => this.bold() ? '500' : 'inherit');
  private readonly textHoverColorValue = computed<string | null>(() =>
    this.hoverColor() ? `var(--color-${this.hoverColor()})` : null
  );

  @HostBinding('style.--text-color')
  protected get textColor(): string {
    return this.textColorValue();
  }

  @HostBinding('style.--text-font-weight')
  get weightValue(): string {
    return this.fontWeightValue();
  }

  @HostBinding('style.--text-hover-color')
  protected get textHoverColor(): string | null {
    return this.textHoverColorValue();
  }
}
